import { InjectionToken } from '@angular/core';

import type { ICdwSaveComponentStateService } from '../interfaces/data-source.interface';

/**
 * `unknown` is the honest type argument here: a single token backed by a
 * single instance serves every grid, and each grid stores a different shape.
 * Injection sites re-declare the write-side `T` they actually use.
 *
 * Note this token's type argument is *not* enforced at `@Inject()` sites —
 * Angular only infers it for the `inject(TOKEN)` form — so it documents
 * intent rather than constraining consumers.
 */
export const CDW_SAVE_COMPONENT_STATE_SERVICE_TOKEN = new InjectionToken<
  ICdwSaveComponentStateService<unknown>
>('CdwSaveComponentStateService');
